import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";
import {currentUser} from "@/firebase/firebaseAuth";
import {StorageReference} from "@firebase/storage";

const storage = getStorage();

export interface FileUploadResult {
    fileRef: StorageReference,
    downloadUrl: string,
}

export function uploadFileToStorage(file: File, path: string, fileType: string): Promise<FileUploadResult> {
  const user = currentUser()
  const uid = user?.uid
  if (!uid) {
    throw new Error('User not signed in')
  }
    const userPath = `${uid}/${path}`
    const fileRef = ref(storage, userPath);

  const metadata = {
    contentType: fileType,
  }

    return uploadBytes(fileRef, file, metadata).then((snapshot) => {
        console.log('Uploaded a blob or file!');
        return getDownloadURL(snapshot.ref).then((downloadUrl) => {
            console.log('File available at', downloadUrl);
            return {fileRef, downloadUrl};
        });
    });

}

export function generateRandomFileName (fileNameLength: number = 10, extension: string = ""): string {
    const randomFileName = generateRandomString(fileNameLength)  + (extension ? '.' + extension : '')
    console.log('Generated random file name', randomFileName)
    return randomFileName;
}

function generateRandomString(length: number = 10) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
}